(function ($) {
    class GM_Header {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.setupResizeObserver();
            this.updateHeaderHeight();
            this.initGTranslateLoader();
        }

        initSelectors() {
            this.$header = $('.header');
            this.$nav = this.$header.find('.nav');
            this.$menuToggle = this.$header.find('.nav__menu-toggle');
            this.$megaMenuTriggers = this.$header.find('.nav__item--mega-menu > a');
            this.$megaMenuColumns = this.$header.find('.mega-menu__column');
            this.$langBtn = this.$header.find('.header__language-btn');
            this.$langWrapper = this.$header.find('.nav__item-language-picker');
            this.mqLg = window.matchMedia('(min-width: 1200px)');
            this.threshold = 100;
            this.lastScrollTop = 0;
            this.root = document.documentElement;
        }

        bindEvents() {
            $(window).on('scroll', () => this.handleScroll());

            this.$menuToggle.on('click', () => this.toggleMenu());

            this.mqLg.addEventListener('change', () => this.handleBreakpointChange());
            this.handleBreakpointChange();

            this.$megaMenuTriggers.on('mouseenter focus', (e) => this.toggleMegaMenu($(e.currentTarget), true));
            this.$megaMenuTriggers.closest('.nav__item--mega-menu').on('mouseleave', (e) => {
                this.toggleMegaMenu($(e.currentTarget).find('> a'), false);
            });
            this.$megaMenuTriggers.on('blur', (e) => {
                // Check if the focus moved outside the entire nav item
                setTimeout(() => {
                    const $parent = $(e.currentTarget).closest('.nav__item--mega-menu');
                    if ($parent.find(':focus').length === 0) {
                        this.toggleMegaMenu($(e.currentTarget), false);
                    }
                }, 10);
            });
        }

        setupResizeObserver() {
            if ('ResizeObserver' in window) {
                const resizeObserver = new ResizeObserver(() => {
                    this.updateHeaderHeight();
                });
                resizeObserver.observe(this.$header[0]);
            }
        }

        updateHeaderHeight() {
            const height = this.$header.outerHeight();
            this.root.style.setProperty('--header-height', `${height}px`);
        }

        handleScroll() {
            const isMenuOpen = this.$menuToggle.attr('aria-expanded') === 'true';

            // Don't hide header or run any logic if menu is open
            if (isMenuOpen) {
                return;
            }

            const currentScrollTop = $(window).scrollTop();

            // At the top of the page - reset header
            if (currentScrollTop <= 0) {
                this.$header.removeClass('header--sticky');
                this.$header.removeAttr('aria-hidden');
                this.$header.removeAttr('inert');
                this.lastScrollTop = currentScrollTop;
                return;
            }

            // Scroll down - hide header
            if (currentScrollTop > this.lastScrollTop && currentScrollTop > this.threshold) {
                if (this.$header.attr('aria-hidden') !== 'true') {
                    this.$header.removeClass('header--sticky');
                    this.$header.attr('aria-hidden', 'true');
                    this.$header.attr('inert', '');
                }
            } 
            // Scroll up - show header as sticky
            else if (currentScrollTop < this.lastScrollTop) {
                if (!this.$header.hasClass('header--sticky')) {
                    this.$header.addClass('header--sticky');
                    this.$header.removeAttr('aria-hidden');
                    this.$header.removeAttr('inert');
                }
            }

            this.lastScrollTop = currentScrollTop;
        }

        toggleMegaMenu($trigger, isOpen) {
            $trigger.attr('aria-expanded', isOpen ? 'true' : 'false');
        }

        toggleMenu() {
            const isExpanded = this.$menuToggle.attr('aria-expanded') === 'true';
            const newState = !isExpanded ? 'true' : 'false';
            this.$menuToggle.attr('aria-expanded', newState);
            this.$nav.attr('aria-expanded', newState);
        }

        handleBreakpointChange() {
            if (this.mqLg.matches) {
                // Desktop - open all
                this.$megaMenuColumns.prop('open', true);
            } else {
                // Mobile - close all
                this.$megaMenuColumns.prop('open', false);
            }
        }

        hideGTranslateLoader() {
            const $body = $('body');
            if (!$body.hasClass('is-translating')) {
                return;
            }

            const elapsedTime = Date.now() - this.translationStartTime;
            const remainingTime = Math.max(0, this.minDisplayTime - elapsedTime);

            setTimeout(() => {
                $body.removeClass('is-translating');
            }, remainingTime);
        }

        initGTranslateLoader() {
            const $body = $('body');
            let loaderTimeout;
            this.translationStartTime = 0;
            this.minDisplayTime = 500; // Total min time to keep loader (in ms)

            // Handle the translation start
            const wrapGTranslate = () => {
                if (typeof window.doGTranslate === 'function' && !window.doGTranslate.isWrapped) {
                    const originalDoGTranslate = window.doGTranslate;
                    window.doGTranslate = (lang_pair) => {
                        this.translationStartTime = Date.now();
                        $body.addClass('is-translating');
                        
                        // Fallback timeout in case callback never fires
                        clearTimeout(loaderTimeout);
                        loaderTimeout = setTimeout(() => {
                            this.hideGTranslateLoader();
                        }, 5000);

                        originalDoGTranslate(lang_pair);
                    };
                    window.doGTranslate.isWrapped = true;
                }
            };

            // Initial wrap attempt
            wrapGTranslate();

            // If not available yet, wrap it when user interacts with language picker
            this.$langWrapper.on('click', 'a', () => {
                wrapGTranslate();
            });

            // GTranslate callback when translation is finished
            window.gt_translate_callback = () => {
                this.hideGTranslateLoader();
            };

            // Detect if Google Translate actually did something by observing DOM changes in <html> attribute
            this.gtranslateObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (document.documentElement.classList.contains('translated-ltr') || 
                            document.documentElement.classList.contains('translated-rtl')) {
                            this.hideGTranslateLoader();
                        }
                    }
                });
            });

            this.gtranslateObserver.observe(document.documentElement, {
                attributes: true
            });
        }
    }

    $(document).ready(() => new GM_Header());
})(jQuery);
